import React from "react";

// A small set of hand-tuned stroke icons (24x24 grid) so we do not need an icon dependency.
const paths = {
    board: <>
        <rect x="3.5" y="3.5" width="17" height="17" rx="2.5"/>
        <path d="M3.5 12h17M12 3.5v17"/>
        <path d="M3.5 3.5h8.5v8.5H3.5zM12 12h8.5v8.5H12z" fill="currentColor" fillOpacity="0.18" stroke="none"/>
    </>,
    users: <>
        <circle cx="9" cy="8" r="3.5"/>
        <path d="M2.5 20c.6-3.6 3.2-5.5 6.5-5.5s5.9 1.9 6.5 5.5"/>
        <path d="M16 4.6a3.4 3.4 0 0 1 0 6.8M17.6 14.7c2.2.6 3.6 2.4 3.9 5.3"/>
    </>,
    trophy: <>
        <path d="M7 4h10v5a5 5 0 0 1-10 0V4z"/>
        <path d="M7 6H4.5a2.5 2.5 0 0 0 2.6 3.8M17 6h2.5a2.5 2.5 0 0 1-2.6 3.8"/>
        <path d="M12 14v3M8.5 20.5h7M9.5 17h5l.8 3.5h-6.6z"/>
    </>,
    user: <>
        <circle cx="12" cy="8" r="4"/>
        <path d="M4 20.5c.8-4.2 4-6.5 8-6.5s7.2 2.3 8 6.5"/>
    </>,
    menu: <path d="M4 7h16M4 12h16M4 17h16"/>,
    close: <path d="M6 6l12 12M18 6L6 18"/>,
    flip: <>
        <path d="M7 4v14M7 4L4 7M7 4l3 3"/>
        <path d="M17 20V6M17 20l-3-3M17 20l3-3"/>
    </>,
    shuffle: <>
        <path d="M3 7h3.5c2.5 0 4 1.5 5.5 5s3 5 5.5 5H21"/>
        <path d="M3 17h3.5c1.4 0 2.5-.5 3.4-1.4M14.1 8.4C15 7.5 16 7 17.5 7H21"/>
        <path d="M18.5 4.5L21 7l-2.5 2.5M18.5 14.5L21 17l-2.5 2.5"/>
    </>,
    sliders: <>
        <path d="M4 7h9M17 7h3M4 17h3M11 17h9"/>
        <circle cx="15" cy="7" r="2"/>
        <circle cx="9" cy="17" r="2"/>
    </>,
    reset: <>
        <path d="M4 12a8 8 0 1 0 2.4-5.7"/>
        <path d="M4 4v4.5h4.5"/>
    </>,
    chevronLeft: <path d="M15 5l-7 7 7 7"/>,
    chevronRight: <path d="M9 5l7 7-7 7"/>,
    chevronsLeft: <path d="M12 5l-7 7 7 7M19 5l-7 7 7 7"/>,
    chevronsRight: <path d="M5 5l7 7-7 7M12 5l7 7-7 7"/>,
    send: <>
        <path d="M21 3L10 14"/>
        <path d="M21 3l-6.5 18-4.5-7-7-4.5z"/>
    </>,
    chat: <path d="M20 12.5a7.5 7.5 0 0 1-11 6.6L4 20l1.1-4.3A7.5 7.5 0 1 1 20 12.5z"/>,
    plus: <path d="M12 5v14M5 12h14"/>,
    check: <path d="M5 12.5l4.5 4.5L19 7.5"/>,
    flag: <>
        <path d="M5 21V4"/>
        <path d="M5 4.5c4.5-2.5 7 2.5 13 0v9c-6 2.5-8.5-2.5-13 0"/>
    </>,
    handshake: <>
        <path d="M3 8.5l3-2 4 1 2.5-1.5 3 .5 5.5 3"/>
        <path d="M3 8.5v6l2 1.5M21 9.5v5l-3 2"/>
        <path d="M12.5 6l-3.3 3.2a1.5 1.5 0 0 0 2.1 2.1l2.2-1.8 4.5 4.3a1.3 1.3 0 0 1-1.9 1.8"/>
        <path d="M16.1 17.5l-1.6-1.4M13.9 18.9l-1.7-1.5M11.6 20l-1.5-1.3"/>
    </>,
    volume: <>
        <path d="M4 9.5v5h3.5L12 19V5L7.5 9.5z"/>
        <path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11"/>
    </>,
    volumeOff: <>
        <path d="M4 9.5v5h3.5L12 19V5L7.5 9.5z"/>
        <path d="M16 9.5l5 5M21 9.5l-5 5"/>
    </>,
    refresh: <>
        <path d="M20 12a8 8 0 0 1-14.3 4.9M4 12a8 8 0 0 1 14.3-4.9"/>
        <path d="M19 3.5V8h-4.5M5 20.5V16h4.5"/>
    </>,
    search: <>
        <circle cx="11" cy="11" r="6.5"/>
        <path d="M16 16l4.5 4.5"/>
    </>,
    arrowRight: <path d="M4 12h15M13 6l6 6-6 6"/>,
    arrowLeft: <path d="M20 12H5M11 6l-6 6 6 6"/>,
    crown: <>
        <path d="M4 8l4 4 4-6 4 6 4-4-1.5 10h-13z"/>
        <path d="M5.5 20.5h13"/>
    </>,
    clock: <>
        <circle cx="12" cy="12" r="8.5"/>
        <path d="M12 7.5V12l3 2"/>
    </>,
    sparkles: <>
        <path d="M11 3.5l1.6 4.4 4.4 1.6-4.4 1.6L11 15.5l-1.6-4.4L5 9.5l4.4-1.6z"/>
        <path d="M18 14l.8 2.2 2.2.8-2.2.8L18 20l-.8-2.2-2.2-.8 2.2-.8z"/>
    </>,
    leaf: <>
        <path d="M5 19c0-8 5-13 15-14-.5 10-6 15-14 15"/>
        <path d="M5 19c3-4 6-6.5 9.5-8.5"/>
    </>,
    userPlus: <>
        <circle cx="10" cy="8" r="3.8"/>
        <path d="M3 20.5c.7-3.9 3.6-6 7-6 1.4 0 2.7.3 3.8 1"/>
        <path d="M18.5 14v6M15.5 17h6"/>
    </>,
    userCheck: <>
        <circle cx="10" cy="8" r="3.8"/>
        <path d="M3 20.5c.7-3.9 3.6-6 7-6 1.4 0 2.7.3 3.8 1"/>
        <path d="M15 17.5l2 2 4-4.5"/>
    </>,
    hourglass: <>
        <path d="M6.5 3.5h11M6.5 20.5h11"/>
        <path d="M7.5 3.5c0 4.5 4.5 5.5 4.5 8.5s-4.5 4-4.5 8.5M16.5 3.5c0 4.5-4.5 5.5-4.5 8.5s4.5 4 4.5 8.5"/>
    </>,
    logout: <>
        <path d="M14 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H14"/>
        <path d="M10 12h10.5M17 8.5l3.5 3.5-3.5 3.5"/>
    </>,
    login: <>
        <path d="M10 4.5h7.5a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H10"/>
        <path d="M3.5 12H14M10.5 8.5L14 12l-3.5 3.5"/>
    </>,
    swords: <>
        <path d="M14.5 17.5L3.5 6.5V3.5h3l11 11"/>
        <path d="M13 19l6-6M16 16l4 4M19 21l2-2"/>
        <path d="M14.5 6.5l3-3h3v3l-3 3M5 14l-1 1M8 17l-1 1M3 21l2-2"/>
    </>,
    eye: <>
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/>
        <circle cx="12" cy="12" r="3"/>
    </>,
    bolt: <path d="M13 3L5 13.5h6L10 21l8-10.5h-6z"/>,
    info: <>
        <circle cx="12" cy="12" r="8.5"/>
        <path d="M12 11v5.5M12 7.6v.2"/>
    </>,
    calendar: <>
        <rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/>
        <path d="M3.5 10h17M8 3v4M16 3v4"/>
    </>,
    sprout: <>
        <path d="M12 21v-8"/>
        <path d="M12 13c0-4 2.5-6.5 7-6.5 0 4.2-2.5 6.5-7 6.5zM12 15.5c0-3.5-2.2-5.5-6.5-5.5 0 3.5 2.2 5.5 6.5 5.5z"/>
    </>,
    upload: <>
        <path d="M12 16V4M7 9l5-5 5 5"/>
        <path d="M4 15v3.5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V15"/>
    </>,
    mail: <>
        <rect x="3" y="5" width="18" height="14" rx="2.5"/>
        <path d="M4 7.5l8 5.5 8-5.5"/>
    </>,
    copy: <>
        <rect x="9" y="9" width="11" height="11" rx="2"/>
        <path d="M5 15V6a2 2 0 0 1 2-2h8"/>
    </>,
    cpu: <>
        <rect x="6.5" y="6.5" width="11" height="11" rx="2.2"/>
        <rect x="9.75" y="9.75" width="4.5" height="4.5" rx="0.8"/>
        <path d="M10 3.5v3M14 3.5v3M10 17.5v3M14 17.5v3M3.5 10h3M3.5 14h3M17.5 10h3M17.5 14h3"/>
    </>,
    undo: <>
        <path d="M9 14L4.5 9.5 9 5"/>
        <path d="M4.5 9.5h9.5a5.5 5.5 0 0 1 0 11H11"/>
    </>,
    chevronLeft: <path d="M14.5 6l-6 6 6 6"/>,
    chevronRight: <path d="M9.5 6l6 6-6 6"/>,
    chevronDown: <path d="M6 9.5l6 6 6-6"/>,
    stop: <rect x="7" y="7" width="10" height="10" rx="2"/>,
    play: <path d="M8 5.5v13l10.5-6.5z"/>
};

const Icon = ({name, size, className, title, strokeWidth = 1.8, style}) => {
    const content = paths[name];
    if (!content) return null;
    return (
        <svg
            className={className}
            width={size || 20}
            height={size || 20}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden={title ? undefined : true}
            role={title ? "img" : undefined}
            style={style}
        >
            {title && <title>{title}</title>}
            {content}
        </svg>
    );
};

export default Icon;
